<template>
    <current-teams v-if="user && teams.length > 0" :user="user" :teams="teams" />
</template>

<script>
import CurrentTeams from './CurrentTeams.vue';

export default {
    props: ['user', 'teams'],

    components: {
        CurrentTeams,
    },
};
</script>
